// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__DAonT","search":"Settings_search__20QnP","filter":"Settings_filter__1Pez_"};